import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { WsgSharedModule } from '@morningstar/wsg/shared';
import { SearchBarDialogComponent } from './search-bar-dialog/search-bar-dialog.component';
import { SearchBarComponent } from './search-bar.component';
import { SearchBarService } from './search-bar.service';

@NgModule({
  declarations: [
    SearchBarComponent,
    SearchBarDialogComponent
  ],
  imports: [
    WsgSharedModule,
    RouterModule
  ],
  exports: [
    SearchBarComponent
  ],
  providers: [
    SearchBarService
  ]
})
export class SearchBarModule { }
